import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import {AppContext} from "../authProvider/AuthProvider";
import {ButtonType, UiButton} from "../ui-components/button/uiButton";
import {useNavigate} from "react-router";


type GameResultType = {
    gameStats: React.ReactNode,
    closePopup: () => void
}

export const GameResult: React.FC<GameResultType> = (props) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {isConnected} = useContext(AppContext)

    return (
        <div className="flex flex-col items-center justify-between h-full">
            <h2 className="text-2xl">{t("game.finished")}!</h2>
            <div className="flex justify-center gap-2">

            {isConnected &&
                <div className="flex flex-col items-center gap-3">
                    <p className="text-xl">{t("stats.game-stats")}</p>

                    <div className="w-full flex justify-around mt-2">
                        {props.gameStats}
                    </div>
                </div>
            }

            </div>
            {
                isConnected ?
                    <div className="flex flex-col w-full gap-2 justify-center 2xl:justify-between 2xl:flex-row">
                        <UiButton
                            type={ButtonType.transparentBg}
                            onClick={() => {navigate("/leaderboard")}}
                            text={t("global.leaderboard")}
                        />
                        <UiButton
                            onClick={() => {props.closePopup()}}
                            text={t("game.restart")}
                        />
                    </div>
                    :
                    <div className="flex flex-col gap-10">
                        <p>{t("game.not-connected")}</p>
                        
                        <UiButton
                            className="w-full !h-fit"
                            onClick={() => {navigate("/login")}}
                            text={t("form.create-account")}
                        />
                    </div>
            }
        </div>
    )
}
